import Grid from "@mui/material/Grid/Grid";
import {ColDef} from "ag-grid-community/dist/lib/entities/colDef";
import {AgGridReact} from "ag-grid-react/lib/agGridReact";
import {RefObject, useCallback, useEffect, useRef, useState} from "react";
import {useRecoilState} from "recoil";
import {useAgGridLocale} from "../../../../../../config/globalConfig";
import AgGridCustomTable from "../../../../../../util/component/AgGridCustomTable";
import {useUpsellingRateDetailRepository} from "../../../../api/repositories/UpsellingRateDetailRepository";
import {
    NewUpsellingRateMatrix,
    UpsellingRateAssociationRequest,
    UpsellingRateDetail,
    UpsellingRateMatrixRecord
} from "../../../../api/types/upsellingRateDetail";
import {ProcessCellForExportParams} from "ag-grid-community";
import {upsellingRateCreationAtom} from "../../../../state/upsellingRatesRecoil";
import {useMatrixColDefs} from "./useMatrixColDefs";
import {GridApi} from "ag-grid-enterprise";
import {BASE_DEFINITION_FORM_STEPS, DEFAULT_MATRIX_COL_DEF} from "../../../../constants";
import PercentageCellEditor from "../../../../common/components/PercentageCellEditor";
import {heightDynamicMatrix} from "../../../../utils";

const UpsellingRateMatrixDefinition = ({submitRef}: { submitRef: RefObject<HTMLButtonElement> }) => {
    // Use State
    const [rowData, setRowData] = useState<{ [key: string]: number | string | null | UpsellingRateDetail }[]>([]);
    const [gridApi, setGridApi] = useState<GridApi | null>(null);

    const onGridReady = (params: any) => {
        setGridApi(params.api);
    };

    // Use Repository Hooks
    const {updateUpsellingRateMatrix} = useUpsellingRateDetailRepository();

    // use Recoil
    const [upsellingRateCreation, setUpsellingRateCreation] = useRecoilState(upsellingRateCreationAtom);
    const {upsellingRateId, readOnly, matrixData, newId} = upsellingRateCreation;

    // Use Ref
    const gridRef = useRef<AgGridReact<UpsellingRateMatrixRecord>>(null);

    // agGrid
    const columnDefs: ColDef[] = useMatrixColDefs({
        matrixData: matrixData as NewUpsellingRateMatrix,
        editable: !readOnly
    });
    const agGridLocale = useAgGridLocale();

    const matrixInit = useCallback(() => {
        if (matrixData?.matrixColumns?.length) {

            const rowData: { [key: string]: number | string | null | UpsellingRateDetail }[] = matrixData?.matrixRows.map(el => {
                const row: { [key: string]: number | string | null | UpsellingRateDetail } = {
                    reservedCarGroup: el.reservedAcriss
                };
                el?.upsellingRateDetails.forEach((detail: UpsellingRateDetail | null, index) => {
                    row[matrixData?.matrixColumns[index]] = detail ? detail : null;
                });
                return row;
            }) || [];

            setRowData(JSON.parse(JSON.stringify(rowData)));
        }
    }, [matrixData]);

    useEffect(() => {
        matrixInit();
    }, [matrixInit]);

    const matrixConfirm = async () => {
        if (newId) {
            const request: UpsellingRateAssociationRequest = {
                upsellingRateId: newId,
                upsellingRateDetails: []
            };

            if (gridApi) gridApi.forEachNodeAfterFilterAndSort((node) => {
                if (node.data) {
                    const row = node.data;
                    Object.values(row).forEach((value) => {
                        typeof value === "object" && value &&
                        request.upsellingRateDetails.push({
                            ...(value as UpsellingRateDetail),
                            amount: (value as UpsellingRateDetail)?.amount
                        });
                    });
                }
            });

            try {
                await updateUpsellingRateMatrix(request);
                setUpsellingRateCreation({...upsellingRateCreation, step: BASE_DEFINITION_FORM_STEPS.DONE});
            } catch (e) {
            }
        }
    };

    const defaultColDef = {...DEFAULT_MATRIX_COL_DEF};


    function processCellFromClipboard(params: ProcessCellForExportParams) {
        if (!isNaN(params.value)) {
            return params.value;
        } else {
            return "";
        }
    }

    console.log(rowData)

    return (
        <Grid container spacing={2} p={2}>
            <Grid item xs={12} sm={12}>
                <AgGridCustomTable
                    gridRef={gridRef}
                    defaultColDef={defaultColDef}
                    columnDefs={columnDefs}
                    height={heightDynamicMatrix(rowData as object[], 97)}
                    frameworkComponents={{
                        customEditor: PercentageCellEditor
                    }}
                    pagination={false}
                    localeText={agGridLocale}
                    tooltipShowDelay={0}
                    stopEditingWhenCellsLoseFocus
                    rowData={rowData}
                    rowSelection={"multiple"}
                    suppressRowClickSelection={true}
                    enableRangeSelection={true}
                    enableCellTextSelection={false}
                    onGridReady={onGridReady}
                    processCellFromClipboard={processCellFromClipboard}
                />
            </Grid>
            <form
                onSubmit={(e) => {
                    e.preventDefault();
                    matrixConfirm();
                }}
            >
                <button ref={submitRef} type="submit" style={{display: "none"}}/>
            </form>
        </Grid>
    );
};

export default UpsellingRateMatrixDefinition;
